import React from 'react'
import FormModalUi from './FormModalUi'

function FormModal({formik,children,handleCloseModal,title}) {
  
  return (
<FormModalUi  formik={formik} handleCloseModal={handleCloseModal} children={children} title={title}/>
)
}

export default FormModal